import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled(Link)`
	display: block;
	color: ${props => props.theme.colors.gray};
	margin-bottom: 3rem;
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;
	perspective: 1000;
	-webkit-perspective: 1000;
	transform: translate3d(0, 0, 0);
`;

export const ImageWrapper = styled.div`
	box-shadow: 0 7px 17px 0 rgba(100, 100, 100, 0.1);
	transition: filter 250ms, box-shadow 250ms;

	&:hover {
		cursor: pointer;
		filter: contrast(115%);
		box-shadow: 0 8px 20px 0 rgba(60, 60, 60, 0.1);
	}
`;

export const Info = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 4.3rem;
	z-index: 2;
`;

export const InfoValue = styled.div`
	font-size: 1.4rem;
	font-weight: 600;
	flex: 1 0 0;
	text-align: center;
`;

export const InfoSep = styled.div`
	height: 2.3rem;
	width: 1px;
	background-color: ${props => props.theme.colors.grayLighter2};
	flex: auto 0 0;
`;

export const Zip = styled.div`
	margin-top: 2rem;
	font-weight: normal;
	font-size: 1.5rem;
	line-height: 2.3rem;
`;

export const NameWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const RentWrapper = styled.div`
	display: flex;
	font-size: 1.5rem;
	line-height: 2rem;
	font-weight: 700;
`;

export const Rent = styled.div`
	color: ${({ theme }) => theme.colors.primary};
`;

export const RentSep = styled.div`
	margin: 0 5px;
`;

export const Name = styled.div`
	font-weight: 700;
	font-size: 2rem;
	color: ${props => props.theme.colors.black};
`;
